import request from '@/router/axios'

// 订货单列表
export function foodmac_orderv2ReserveGoodsPagelist (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/pageList`,
    method: 'post',
    data
  })
}

// 订货单详情分类列表
export function foodmac_orderv2ReserveGoodsMenutypelist (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/menuTypeList`,
    method: 'post',
    data
  })
}

// 计算商品价格
export function foodmac_orderv2ReserveGoodsSumgoods (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/sumGoods`,
    method: 'post',
    data
  })
}

// 新增订货单
export function foodmac_orderv2ReserveGoodsAddreservegoods (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/addReserveGoods`,
    method: 'post',
    data
  })
}

// 编辑订货单
export function foodmac_orderv2ReserveGoodsUpdatereservegoods (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/updateReserveGoods`,
    method: 'post',
    data
  })
}

// 新增订货单回显
export function foodmac_orderv2ReserveGoodsAddreservegoodsinfo (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/addReserveGoodsInfo`,
    method: 'post',
    data
  })
}

// 订货单详情
export function foodmac_orderv2ReserveGoodsReservegoodsdetail (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/reserveGoodsDetail`,
    method: 'post',
    data
  })
}

// 更新订货单
export function foodmac_orderv2ReserveGoodsUpdatereserve (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/updateReserve`,
    method: 'post',
    data
  })
}

// 导出订货单详情
export function foodmac_orderv2ReserveGoodsExportreservegoodsdetail (data) {
  return request({
    url: `/foodmac_orderv2/reserve/goods/exportReserveGoodsDetail`,
    method: 'post',
    data
  })
}


